import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state ids for the Heidi II nudges shown after "Explore later".
 *
 * The backend adds these to its `ModalId` enum (ml-scribe
 * `shared/enums/modal_tracking.py`), but the generated schema has not been
 * regenerated since, so they are cast here the way the prechart ids were
 * until their regeneration. Unlike the local-regime casts in
 * `modal-queue.types.ts`, these ARE posted to the backend (`showOnce` and
 * `markModalAsViewed`), so the surfaces must stay behind the Heidi II
 * onboarding flag until the backend enum is deployed. Once
 * `pnpm run schema:dev` picks them up, swap each cast for `ModalId.X`; the
 * id strings are frozen because they key `seen_modals`.
 */
export const HEIDI_2_EXPLORE_LATER_BANNER_MODAL_ID =
  'T4_CUSTOM_AUDIENCE_HEIDI_2_EXPLORE_LATER_BANNER' as ModalId;

/** The Home tour (Home rail, Recents, Evidence); also drives the Home nav dot. */
export const HEIDI_2_EVIDENCE_TOUR_SPOTLIGHT_MODAL_ID =
  'T4_CUSTOM_AUDIENCE_HEIDI_2_EVIDENCE_TOUR_SPOTLIGHT' as ModalId;

export const HEIDI_2_GET_STARTED_CHECKLIST_MODAL_ID =
  'T4_CUSTOM_AUDIENCE_HEIDI_2_GET_STARTED_CHECKLIST' as ModalId;
